import { render, staticRenderFns } from "./uploadImageForm.vue?vue&type=template&id=6464a404&scoped=true&"
import script from "./uploadImageForm.vue?vue&type=script&lang=js&"
export * from "./uploadImageForm.vue?vue&type=script&lang=js&"
import style0 from "./uploadImageForm.vue?vue&type=style&index=0&id=6464a404&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6464a404",
  null
  
)

export default component.exports